import(/* webpackMode: "eager", webpackExports: ["Card","CardHeader","CardTitle","CardContent"] */ "/vercel/path1/src/components/ui/card.tsx");
